<script>
	import { uiText } from "../lib/uiText.js";
	let year = new Date().getFullYear();
	export let joinCode = false;
	export let lang = "en";
	let ui = uiText(lang);
	export const v = "?rev=06171920";
	export let vendor = ui.game.footer.vendor;
	$: lang, (ui = uiText(lang)), (vendor = ui.game.footer.vendor);
</script>

<footer id="footer" class="grid self-end m-4 text-center justify-items-center">
	<p>
		{#if joinCode}
			{ui.game.footer.join_code}
			{joinCode}
			<br />
		{/if}
		{year} &copy; {vendor}
		<br />
		{ui.game.footer.powered_by}
		<a href="mailto:obelisk@vutreshenglas.com"><strong>Obelisk</strong></a>
		<span class=" opacity-30">v2.6{v.substring(7, 9) + v.substring(5, 7)}</span>
	</p>
</footer>
